import { WSForm, WSInputText } from "@wingspanhq/fe-component-library";
import { IAttributeDefinition } from "@wingspanhq/payments/dist/interfaces";

type Props = {
  definition: IAttributeDefinition;
};

export const FieldString: React.FC<Props> = props => {
  return (
    <WSForm.Field
      name={props.definition.key}
      component={WSInputText}
      componentProps={{
        label: props.definition.name,
        helperText: props.definition.description,
        required: props.definition.required
      }}
    />
  );
};
